import React from 'react'
import styled from '@emotion/styled'
import GlobalCSS from 'src/components/GlobalCSS'
import SEO from 'src/components/seo'
import SubPageTopLayout from 'src/components/organisms/SubPageTopLayout'
import CompanyInformation from 'src/components/organisms/company/CompanyInformation'
import CompanyVmv from 'src/components/organisms/company/CompanyVmv'
import CompanyMembers from 'src/components/organisms/company/CompanyMembers'
import Header from 'src/components/organisms/Header'
import Footer from 'src/components/organisms/Footer'
import CompanyNews from 'src/components/organisms/company/CompanyNews'

class Company extends React.Component {
  render() {
    return (
      <>
        <SEO
          title="会社概要"
          description="企業とユーザーが融け合うコミュニティサクセスプラットフォームcommmune(コミューン)を運営する、コミューン株式会社の会社概要ページです。"
        />
        <Container>
          <GlobalCSS />
          <Header />
          <SubPageTopLayout title="会社概要" heading="COMPANY" />
          <CompanyInformation />
          <CompanyNews />
          <CompanyVmv />
          <CompanyMembers />
          <Footer />
        </Container>
      </>
    )
  }
}

const Container = styled.div`
  z-index: 0;
  position: relative;
  overflow: hidden;
`

export default Company
